// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { mb, mt, px } from 'styled-components-spacing';
import { StyledCoverMaxWidthPadding } from '@components/Wrappers';

import { fontTeaserItalic } from '@styles/typography';
import theme from '@theme';
import { RichTextStyle } from '@lib/styles/richtextEditiorStyles';

const { colors } = theme;

export const StyledTextContent = styled.div`
  ${RichTextStyle}
  img {
    max-width: 100% !important;
    max-height: 65vh !important;
    height: auto;
    width: auto;
    display: block;
    margin: auto;
  }
  p{
    margin-bottom: 10px;
  }
`;

export const MainSubHeadline = styled.h2`
padding-top: 2.5rem;
  color: ${({ textcolor }) => textcolor || 'black'};
  ${({ center }) => center && 'text-align: center'};
  ${({ mt }) => mt && 'margin-top: 30px'};
  font-size: 32px;
  line-height: 1.2;
  font-weight: 700;
  margin-bottom: 2.5rem;
  ${({ center }) =>
    center
    && `
    text-align: center;
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 22px;
  `}
  ${breakpoint('mobile', 'tablet')`
  padding-top: 1.5rem;
    font-size: 18px;
    margin-bottom: 1.5rem;
  `}
`;

export const StyledVerticalSpacerColored = styled.div`
  display: flex;

  flex: 1;
  ${({ color }) => color && `background-color: ${color}`};
`;

export const StyledCover = styled(StyledCoverMaxWidthPadding)`
  ${mb(0)}
  overflow: hidden;

  ${breakpoint('desktop')`
  overflow: visible
    ${mb(0)}
  `}
`;

export const StyledCardsMaxWidth = styled.div`
  max-width: 1400px;
  padding: 0 1rem;
  margin: auto;

  ${breakpoint('mobile', 'desktop')`
   padding: 0px;
  `}
`;

export const StyledArticleTitle = styled.h1`
  ${mt(4)}
  ${theme.typography.Raleway}
  font-size: 28px;
  font-weight: 500;
  word-break: break-word;
  line-height: 1.5;
  text-align: center;
  color: ${colors.darkBlue};
  margin: 1rem auto;
  ${px(2)}

  ${breakpoint('desktop')`
    margin: 0 auto;
    max-width: 920px;
    line-height: 1.4;
    word-break: normal;
    margin: 2rem auto;
    z-index: 10;
    position: relative;
    font-size: 32px;
    font-weight: 600;
  `}
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
`;

export const StyledCategoryScrollableWrapper = styled.div`
  width: 100%;
  overflow-x: scroll;
  ${breakpoint('mobile', 'tablet')`
      scrollbar-width: thin;
  margin-bottom: 1rem;
  `}

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledCategoryTagsWrapper = styled.div`
  display: flex;
  margin-bottom: 1rem;
  width: fit-content;
  align-items: center;
  white-space: nowrap;
  padding-left: 6px;

  & > span:last-child {
    display: none;
  }

  ${breakpoint('desktop')`
     padding-left: 6px;
    margin-bottom: 2rem;
  `}
`;

export const StyledCategoryTag = styled.a`
  font-weight: 700;
  text-decoration: none !important;
  transition: 0.3s;
  :hover {
    transform: scale(1.1);
  }
  cursor: pointer;
  color: #408ba5;
`;

export const StyledTagSeperator = styled.span`
  width: 1px;
  height: 26px;
  margin: 0 30px;
  background-color: #408ba5;
`;

export const StyledImageContainer = styled.div`
  width: 100%;
  overflow: hidden;
  margin-bottom: 3rem;
  img {
    width: auto;
    max-width: 100%;
    margin: auto;
    display: block;
  }

  ${breakpoint('mobile', 'desktop')`
    margin-bottom: 1.5rem;
  `}
`;

export const StyledDateAndLinkContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-left: 6px;
  margin-top: auto;
  margin-bottom: 0.5rem;
  color: #a6adbc;
  font-weight: 700;
  & > span {
    ${fontTeaserItalic}
    font-weight: 600;
  }
`;
export const StyledSwiper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0px !important
  }

  .swiper-container-android .swiper-slide, .swiper-wrapper {
    margin-bottom: 2rem;
  }

   .swiper-button-prev,
.swiper-button-next {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 40px;
  height: 40px;
   top: 50%;
  transform: translateY(-50%);
  z-index: 10;

}
 .swiper-button-prev {
  left: -10px;
  background-image: url('/svg/packageScreen/prev-arrow.svg');
}

.swiper-button-next {
   right: -10px;
   background-image: url('/svg/packageScreen/next.svg');
}
.swiper-button-prev::after,
.swiper-button-next::after {
  display: none;
}

   .swiper-slide {
    /* transform: scale(0.95); */
    transition: transform 0.3s ease;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .swiper-button-disabled {
  opacity: 0.3;
  pointer-events: none;
}
`;
